import { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { Building2, Package, ShoppingCart, IndianRupee, ArrowUpRight } from "lucide-react";
import { api, formatINR, formatCompactNumber } from "@/lib/api";

export default function MallOwnerOverview() {
  const { user } = useOutletContext();
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/mall-owner/overview").then((r) => setStats(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="mall-owner-overview">
      <div className="text-[11px] uppercase tracking-[0.3em] font-semibold text-[var(--gold)]">Console · Mall Admin</div>
      <h1 className="mt-3 font-serif-display text-4xl lg:text-5xl text-[var(--ink)]">
        Welcome, <span className="font-serif-italic text-[var(--gold)]">{user?.name?.split(" ")[0]}.</span>
      </h1>
      <p className="mt-2 text-[var(--slate-1)]">Manage your malls, inventory and bookings on Fundle.</p>

      <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-px bg-[var(--border)]">
        <Card icon={Building2} label="Malls" value={stats?.malls} to="/mall-owner/malls" />
        <Card icon={Package} label="Ad spaces listed" value={stats?.inventory} to="/mall-owner/inventory" />
        <Card icon={ShoppingCart} label="Bookings" value={stats?.bookings} to="/mall-owner/bookings" />
        <Card icon={IndianRupee} label="Confirmed revenue" value={stats ? formatCompactNumber(stats.total_revenue) : null} to="/mall-owner/bookings" prefix="₹" />
      </div>

      <div className="mt-14 surface p-8">
        <div className="text-[11px] uppercase tracking-[0.3em] font-semibold text-[var(--gold)]">Operating notes</div>
        <h3 className="mt-3 font-serif text-2xl text-[var(--ink)]">Keep availability current to maximise bookings.</h3>
        <p className="mt-3 text-[var(--slate-1)]">
          Mark placements as <em>Available</em>, <em>Limited</em>, or <em>Booked</em> from the
          inventory page. Advertisers see live status when they shortlist or request proposals.
        </p>
        <Link to="/mall-owner/inventory" className="mt-6 inline-flex btn-primary">
          Manage inventory <ArrowUpRight size={14} />
        </Link>
      </div>
    </div>
  );
}

function Card({ icon: Icon, label, value, to, prefix }) {
  return (
    <Link to={to} className="bg-[var(--bone)] p-6 hover:bg-white transition" data-testid={`mo-card-${label.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="flex items-center justify-between">
        <Icon size={18} className="text-[var(--gold)]" />
        <ArrowUpRight size={14} className="text-[var(--slate-2)]" />
      </div>
      <div className="mt-5 font-serif-display text-4xl text-[var(--ink)]">{value != null ? `${prefix || ""}${value}` : "—"}</div>
      <div className="mt-1 text-[10px] uppercase tracking-[0.22em] text-[var(--slate-2)]">{label}</div>
    </Link>
  );
}
